import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        report: {},
        base_url: ''
    },
    mutations: {
        setReport (state, payload) {
            state.report = payload;
        },
        setBaseUrl (state, payload) {
            state.base_url = payload;
        }
    },
    getters: {
        getReport: state => state.report,        
        base_url: state => state.base_url,
    },
    actions: {
        getBaseUrl({ commit }) {
            console.log('Set base url action');
            return new Promise((resolve, reject) => {
                axios.get('/base_url_imgs_persons')
                    .then(result => {
                        commit('setBaseUrl', result.data);
                        console.log('Result from axios getbase url action: ', result.data);
                        resolve();
                    })
                    .catch(error => {
                        reject(error.response && error.response.data.message || 'Error.');
                    });
            });
        },
    }
});